var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeVendas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.304 1.01575C6.79036 1.38012 0 8.39751 0 17.0009C0 25.8374 7.16344 33.0009 16 33.0009C24.1295 33.0009 30.8429 26.938 31.8652 19.0872H30.8561C29.8407 26.384 23.5763 32.0009 16 32.0009C7.71573 32.0009 1 25.2852 1 17.0009C1 8.94988 7.34285 2.38033 15.304 2.01674V1.01575Z",
    fill: "#D91F05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8047 0.999878L15.8047 18.737",
    stroke: "#D91F05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8651 19.1953L15.3044 19.1953",
    stroke: "#D91F05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15V1C29.6 2.24444 32 10.8519 32 15H20Z",
    stroke: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeVendas);
export default __webpack_public_path__ + "static/media/volumeVendas.b9bc7a576ebd30c58dd9e53bd260f810.svg";
export { ForwardRef as ReactComponent };